module.exports = __webpack_public_path__ + "static/weedleafdance-8f7c1138117f6de092b44aaf998658a9.gif";